<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<button mat-icon-button style="color: rgba(230, 176, 18);" [matMenuTriggerFor]="notificacion"
  [matBadge]="nuevasNotificacions" matBadgePosition="before" [matBadgeHidden]="nuevasNotificacions === 0"
  matBadgeSize="small" #menuTriggerNotificaciones="matMenuTrigger" matTooltip="Notificaciones">
  <mat-icon>notifications</mat-icon>
</button>

<button mat-button [matMenuTriggerFor]="profile" class="m-r-5 profile-chip">
  <span class="profile-chip__avatar">
    <img *ngIf="!cargandoImagen" [src]="(getfoto == '') ? '../../../../assets/images/users/16196015_10154888128487744_6901111466535510271_n.png' : getfoto" alt="user"
      class="profile-chip__avatar-img">
  </span>
  <b class="profile-chip__name">{{dataUsuario?.Nombre || dataUsuario?.Usuario}}</b>
  <mat-icon class="profile-chip__chevron">expand_more</mat-icon>
</button>

<mat-menu #profile="matMenu" class="mymegamenu">
  <button mat-menu-item [routerLink]="['/perfil']">
    <mat-icon>manage_accounts</mat-icon> Configuración
  </button>
  <!-- <button mat-menu-item [routerLink]="['seguridad/personalizacion']">
    <mat-icon>format_paint</mat-icon> Personalizar
  </button> -->
  <!-- <button mat-menu-item [routerLink]="['cambioPassword/2']" style="background-color: rgb(236, 77, 77);">
    <mat-icon>vpn_key</mat-icon> Cambiar Contraseña
  </button> -->
  <button mat-menu-item (click)="authServices.CerrarSesion()" class="exit">
    <mat-icon>exit_to_app</mat-icon> Salir
  </button>
</mat-menu>

<mat-menu #notificacion="matMenu" class="MenuNotificaciones" xPosition="before" [hasBackdrop]="true"
  backdropClass="custom-backdrop" overlayPanelClass="custom-backdrop-2">
  <div class="header_notificaciones">
    <button mat-icon-button (click)="cerrarMenu()" class="button_close"><mat-icon>close</mat-icon></button>
    <p class="header_notificaciones__title">
      Notificaciones
    </p>
    <p class="header_notificaciones__subtitle"
      *ngIf="nuevasNotificacions > 0">Notificaciones pendientes de leer: {{nuevasNotificacions}}</p>

    <div class="header_notificaciones__actions">
      <button type="button" mat-raised-button class="buttonPrincipal"
        (click)="marcarNotificacionesVista(); $event.stopPropagation()">Marcar todo como leido</button>
      <button mat-raised-button class="buttonSecundary"
        [routerLink]="['/template/afiliados/historial-notificaciones']">Ver historial notificaciones</button>
    </div>
  </div>
  <div class="notificaciones-body">

    <p class="notificaciones-empty"
      *ngIf="notificaciones?.length === 0">No has recibido notificaciones</p>

    <p class="notificaciones-empty"
      *ngIf="nuevasNotificacions === 0 && notificaciones?.length > 0">No has recibido nuevas notificaciones</p>


    <cdk-virtual-scroll-viewport appendOnly itemSize="50" style="height: 30vh;" *ngIf="notificaciones?.length > 0">
      <mat-list>
        <ng-container *cdkVirtualFor="let notificacion of notificaciones" class="example-item"
          style="height: auto !important;" class="mat-list-item-notificacion">

          <mat-list-item *ngFor="let folder of folders">
            <mat-icon mat-list-icon>folder</mat-icon>
            <div mat-line>{{folder.name}}</div>
            <div mat-line> {{folder.updated | date}} </div>
          </mat-list-item>
          <mat-list-item>
            <mat-icon mat-list-icon>star</mat-icon>
            <div mat-line
              style="white-space: break-spaces !important; font-size: 14px; font-weight: 800; line-height: 16px;">{{notificacion?.asunto}}</div>
            <div mat-line style="white-space: break-spaces !important; font-size: 14px; font-weight: 400; line-height: 16px;">{{notificacion?.mensaje}}</div>
            <div mat-line style="white-space: break-spaces !important; font-size: 14px; font-weight: 400; line-height: 16px;">{{(notificacion?.visto
              === false) ? 'Nueva Notificación' : 'Notificación Vista'}}</div>
            <div mat-line style="font-size: 14px; font-weight: 400; line-height: 16px; white-space: break-spaces !important;">Fecha Notificación: <br>
              {{notificacion?.fechaRegistro | date: 'yyyy-MM-dd'}}</div>

            <div mat-line class="mat-list-item-notificacion__accion" *ngIf="!notificacion?.visto">
              <button mat-mini-fab matTooltip="Marcar como leído" class="buttonPrincipal"
                (click)="marcarVisto(notificacion); $event.stopPropagation()" type="button">
                <mat-icon>mark_email_read</mat-icon>
              </button>
            </div>
          </mat-list-item>
          <mat-divider style="margin: 10px 0px;"></mat-divider>
        </ng-container>


      </mat-list>

    </cdk-virtual-scroll-viewport>


  </div>

</mat-menu>